import { useState, useRef, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import client from "@/lib/api";

// Persists a page's filter object to the logged-in user's profile
// (preferences[key]) so their preferred list view survives navigation and reloads.
export function usePersistedFilters(key, defaults) {
  const { user, patchPreferences } = useAuth();
  const saved = user?.preferences?.[key];
  const [filters, setFilters] = useState(() => ({ ...defaults, ...(saved || {}) }));
  const hydrated = useRef(false);

  useEffect(() => {
    if (!hydrated.current) { hydrated.current = true; return; }
    patchPreferences({ [key]: filters });
    const t = setTimeout(() => {
      client.put("/me/preferences", { preferences: { [key]: filters } }).catch(() => {});
    }, 600);
    return () => clearTimeout(t);
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  return [filters, setFilters];
}
